import React from "react";

export default function MatchRing({ score = 0, size = 88 }) {
  const r = (size - 10) / 2;
  const c = 2 * Math.PI * r;
  const dash = (score / 100) * c;
  return (
    <div className="relative" style={{ width: size, height: size }} data-testid={`match-ring-${score}`}>
      <svg width={size} height={size} className="-rotate-90">
        <defs>
          <linearGradient id="ai-grad" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stopColor="hsl(var(--ai-1))" />
            <stop offset="100%" stopColor="hsl(var(--ai-2))" />
          </linearGradient>
        </defs>
        <circle cx={size / 2} cy={size / 2} r={r} stroke="hsl(var(--border))" strokeWidth="6" fill="none" />
        <circle
          cx={size / 2} cy={size / 2} r={r}
          stroke="url(#ai-grad)" strokeWidth="6" fill="none"
          strokeDasharray={`${dash} ${c}`} strokeLinecap="round"
        />
      </svg>
      <div className="absolute inset-0 grid place-items-center">
        <div className="text-center leading-none">
          <div className="font-display text-2xl font-semibold">{score}</div>
          <div className="text-[10px] uppercase tracking-[0.2em] text-muted-foreground">match</div>
        </div>
      </div>
    </div>
  );
}
